<template>
  <DarkCard>
    <template #header>
      <div>Active Alerts</div>
      <i class="fa fa-comment-o"></i>
    </template>
    <template #body>
      <span>{{ alerts ?? '--' }} </span>
    </template>
  </DarkCard>
</template>

<script>
import { EventLogStatus } from '@/enums'
import DarkCard from './DarkCard.vue'
import { getEvents } from '@/api'
import { EventBus } from '@/event-bus'

export default {
  name: 'ActiveAlerts',
  components: {
    DarkCard
  },
  data() {
    return {
      alerts: null
    }
  },
  methods: {
    //Active Alerts应该是右边event log里面还没有被Resolved的alert的数量吧
    async fetchActiveAlerts() {
      // 这里可以替换为实际的 API 调用
      const res = await getEvents({ status: EventLogStatus.OPEN, limit: 0, offset: 0 })
      this.alerts = res.totalCount
    }
  },
  mounted() {
    // 这里可以替换为实际的 API 调用
    this.fetchActiveAlerts()
    EventBus.$on('event-log-refreshed', this.fetchActiveAlerts);
  },
  beforeDestroy() {
    EventBus.$off('event-log-refreshed', this.fetchActiveAlerts);
  }
}
</script>
